import type { Base_Bus } from '../Base/Base.Bus'
import { Cust_hasSingleLocation } from '../Cust/Cust.serverPrefs'
import { DS_setData } from '../DS/DS.Data'
import { Serv_client } from '../Serv/Serv.client'
import { Sync_standardSync } from '../Sync/Sync.standardSync'
import { Todo_toDoneReportDPO } from './Todo.DoneReport'
import { Todo_toScheduledInstanceDPO } from './Todo.ScheduledInstance'
import {
    IDB_doneReports,
    IDB_scheduledInstances,
    IDB_syncParamsDoneReports,
    IDB_syncParamsTodos,
} from '../IDB/IDB.dexie'
import { isOnline } from '../Serv/Serv.socketClient'

export async function Todo_sync() {
    if (!(await isOnline())) return
    if (!Cust_hasSingleLocation()) return

    await Promise.all([
        // Done reports
        Sync_standardSync({
            params: IDB_syncParamsDoneReports(),
            sync: Serv_client.syncDone,
            write: async (response) => {
                await IDB_doneReports().bulkPut(response.doneReports.map(Todo_toDoneReportDPO))
                await IDB_doneReports().bulkDelete(response.reportClientIdsToDelete as any[])
            },
            clear: () => IDB_doneReports().clear(),
        }),

        // Scheduled instances
        Sync_standardSync({
            params: IDB_syncParamsTodos(),
            sync: Serv_client.syncTodo,
            write: async (response) => {
                await IDB_scheduledInstances().bulkPut(response.scheduledInstances.map(Todo_toScheduledInstanceDPO))
            },
            clear: () => IDB_scheduledInstances().clear(),
        }),
    ])

    // Trigger any re-renders depending on todo items
    DS_setData('TodoSynced', () => ({
        todoSyncTime: Date.now(),
    }))
}

export function Todo_requestSync(label: string, bus: Base_Bus) {
    return bus.addTask('todo_sync', label)
}
